
export const finalYear = [

    {
        "url": require('../Assets/FinalYearImg/heeth.jpeg'),
        "name": "Heeth Bhandari",
        "position": "President",
        "instaLink": "https://www.instagram.com/heethbhandari_20?r=nametag",
        "linkedinLink": "https://www.linkedin.com/in/heeth-b-13405922a",
    },
    {
        "url": require('../Assets/FinalYearImg/Shubham Roy.jpg'),
        "name": "Shubham Roy",
        "position": "General Secretary",
        "instaLink": "https://www.instagram.com/shubhamaaay1?r=nametag",
        "linkedinLink": "https://www.linkedin.com/in/shubham-roy-428080273",
    },
     {
        "url": require('../Assets/FinalYearImg/Swaraj Jaiswal.jpeg'),
        "name": "Swaraj Jaiswal",
        "position": "Treasurer",
        "instaLink": "https://www.instagram.com/_swaraj_jaiswal_?igsh=OXZ0a3Vtb20wZ2di",
        "linkedinLink": "https://www.linkedin.com/in/swaraj-jaiswal-0b5304283?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    {
        "url": require('../Assets/FinalYearImg/Anuj kardam.jpg'),
        "name": "Anuj Kardam",
        "position": "Vice President",
        "instaLink": "https://www.instagram.com/_anuj__007_?r=nametag",
        "linkedinLink": "https://www.linkedin.com/in/anuj-kardam-156b15203?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    {
        "url": require('../Assets/FinalYearImg/Sudeep Routray.jpg'),
        "name": "Sudeep Routray",
        "position": "Vice President",
        "instaLink": "https://www.instagram.com/sudeep_ra4?igsh=YWE2YnlzaWFsbjJ2",
        "linkedinLink": "https://www.linkedin.com/in/sudeep-kumar-routray-53a86527b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    {
        "url": require('../Assets/FinalYearImg/BINAYAK DEY.jpg'),
        "name": "Binayak Dey",
        "position": "Assistant General Secretary",
        "instaLink": "",
        "linkedinLink": "https://www.linkedin.com/in/binayak-dey-a4b36828a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
       {
        "url": require('../Assets/FinalYearImg/Aubanti2.jpg'),
        "name": "Aubanti Boshu",
        "position": "Convenor",
        "instaLink": "https://www.instagram.com/diya0111?r=nametag",
        "linkedinLink": "https://www.linkedin.com/in/aubanti-boshu-5a0b612b3?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    },

    {
        "url": require('../Assets/FinalYearImg/Sai Rohan2.jpeg'),
        "name": "Durga Sai Rohan",
        "position": "Convenor",
        "instaLink": "https://www.instagram.com/sairohan_22?r=nametag",
        "linkedinLink": "https://www.linkedin.com/in/b-durga-sai-rohan-94334a291?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },

    {
        "url": require('../Assets/FinalYearImg/Sachin Kumar Yadav .jpg'),
        "name": "Sachin Kumar Yadav",
        "position": "Head of Coorporate Communications",
        "instaLink": "https://www.instagram.com/s.achi.n__?r=nametag",
        "linkedinLink": "https://www.linkedin.com/in/sachin-kumar-yadav-10b3b8298",
    },
        {
        "url": require('../Assets/FinalYearImg/Shikhar Gupta .jpg'),
        "name": "Shikhar Gupta",
        "position": "Head of Operations",
        "instaLink": "https://www.instagram.com/shikhargt03?r=nametag",
        "linkedinLink": "https://www.linkedin.com/in/shikhar-gupta-a251a5294",
    },
    {
        "url": require('../Assets/FinalYearImg/Monisha.jpeg'),
        "name": "Monisha",
        "position": "Head of Operations",
        "instaLink": "https://www.instagram.com/mon_._isha?r=nametag",
        "linkedinLink": "https://www.linkedin.com/in/monisha-b354b2308?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
        {
        "url": require('../Assets/FinalYearImg/Shasvat Singh.jpeg'),
        "name": "Shasvat Singh",
        "position": "Design Head",
        "instaLink": "https://www.instagram.com/_.shasvat.__?igsh=Ynp4a3Vka2d3aDA0&utm_source=qr",
        "linkedinLink": "https://www.linkedin.com/in/shasvat-singh-0078b1307/",
    },
    {
        "url": require('../Assets/FinalYearImg/Durga Sagar.jpg'),
        "name": "Durga Sagar",
        "position": "Visual Media Head",
        "instaLink": "",
        "linkedinLink": "",
    },
        {
        "url": require('../Assets/FinalYearImg/Kritanu.jpeg'),
        "name": "Kritanu Chattopadhyay",
        "position": "BAJA Head",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/FinalYearImg/Dibyaranjan Nayak .jpg'),
        "name": "Dibyaranjan Nayak",
        "position": "Technical Head",
        "instaLink": "https://www.instagram.com/dibya.9778?utm_source=qr&igsh=eXUzOGplM2ZuYjhl",
        "linkedinLink": "https://www.linkedin.com/in/dibya-ranjan-nayak-35a2b92b7?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    {
        "url": require('../Assets/FinalYearImg/Rishi Singh .jpg'),
        "name": "Rishi Singh",
        "position": "Technical Head",
        "instaLink": "https://www.instagram.com/rishisingh6146?r=nametag",
        "linkedinLink": "https://www.linkedin.com/in/rishi-singh-3baa99306",
    },

    {
        "url": require('../Assets/FinalYearImg/Alok.jpeg'),
        "name": "Alok Kumar",
        "position": "Automobile Head",
        "instaLink": "",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/FinalYearImg/Lakshay Attri.jpeg'),
        "name": "Lakshay Attri",
        "position": "Automobile Head",
        "instaLink": "https://www.instagram.com/lakshay_attri_001?r=nametag",
        "linkedinLink": "https://www.linkedin.com/in/lakshay-attri-5a18b1307?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
        {
        "url": require('../Assets/FinalYearImg/Aashish Patel.jpg'),
        "name": "Aashish Patel",
        "position": "Web Development Head",
        "instaLink": "https://www.instagram.com/_aa_ss_hh_ii_ss_hh_?r=nametag",
        "linkedinLink": "https://www.linkedin.com/in/ashish-patel-79aa90281?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    {
        "url": require('../Assets/FinalYearImg/Jayasree Maddu.jpeg'),
        "name": "Maddu Jayasree",
        "position": "Web Development Head",
        "instaLink": "https://www.instagram.com/jayasreemaddu?r=nametag",
        "linkedinLink": "",
    },

    {
        "url": require('../Assets/FinalYearImg/Lakshanyaa B .jpg'),
        "name": "Lakshanyaa B",
        "position": "Creative Head",
        "instaLink": "https://www.instagram.com/lakshanyaab?r=nametag",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/FinalYearImg/Rohan Dey .jpg'),
        "name": "Rohan Dey",
        "position": "Creative Head",
        "instaLink": "https://www.instagram.com/_rohandey78?r=nametag",
        "linkedinLink": "https://www.linkedin.com/in/rohan-dey-5a68b2307?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    {
        "url": require('../Assets/FinalYearImg/Kashish.jpeg'),
        "name": "Kashish Sonkar",
        "position": "Head ATH",
        "instaLink": "https://www.instagram.com/_kashish_0603?r=nametag",
        "linkedinLink": "https://www.linkedin.com/in/kashish-sonkar-23950728a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    {
        "url": require('../Assets/FinalYearImg/Sonu Mahata.png'),
        "name": "Sonu Mahata",
        "position": "Head ATH",
        "instaLink": "https://www.instagram.com/_sm. stark_?r=nametag",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/FinalYearImg/Govardhan Reddy.png'),
        "name": "Govardhan Reddy",
        "position": "PR and Outreach Head",
        "instaLink": "https://www.instagram.com/govardhan__023?r=nametag",
        "linkedinLink": "",
    },
    {
        "url": require('../Assets/FinalYearImg/Rohit Singh .jpg'),
        "name": "Rohit Singh",
        "position": "Workshop Head",
        "instaLink": "https://www.instagram.com/_.rohit_321?r=nametag",
        "linkedinLink": "https://www.linkedin.com/in/rohit-singh-6993b1277?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    {
        "url": require('../Assets/FinalYearImg/Regam Jeswanth Dora.jpg'),
        "name": "Jeswanth Regam",
        "position": "Events Head",
        "instaLink": "https://www.instagram.com/jeswanth_r_j_22?utm_source=qr&igsh=MXI1b25yM213YXhubQ==",
        "linkedinLink": "https://www.linkedin.com/in/aman-singh-16273727a",
    },
    {
        "url": require('../Assets/FinalYearImg/Shagupta-Paul.jpeg'),
        "name": "Shagupta Paul",
        "position": "Events Head",
        "instaLink": "",
        "linkedinLink": "",
    },
    

    
    

    /*{
        "url": require('../Assets/FinalYearImg/Dibyaranjan Das.jpg'),
        "name": "Dibyaranjan Das",
        "position": "Junior Coordinator",
        "instaLink": "https://www.instagram.com/dibya.nitdgp4470?r=nametag",
        "linkedinLink": "https://www.linkedin.com/in/dibyaranjan-das-0622b42b7?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },*/
    
    
    /*{
        "url": require('../Assets/FinalYearImg/Dibyendu Majhi .jpg'),
        "name": "Dibyendu Majhi",
        "position": "Junior Coordinator",
        "instaLink": "https://www.instagram.com/dibyendu_itsme?r=nametag",
        "linkedinLink": "h",
    },*/
    
    

    /*{
        "url": require('../Assets/FinalYearImg/Abdus Sayeed.jpg'),
        "name": "Abdus Sayeed",
        "position": "Junior Coordinator",
        "instaLink": "https://www.instagram.com/shehryaar_123?r=nametag",
        "linkedinLink": "https://www.linkedin.com/in/abdus-sayeed-087671308",
    },*/


    

    


    
    
    
    /*{
        "url": require('../Assets/FinalYearImg/Nivedita Kesh.jpg'),
        "name": "Nivedita Kesh",
        "position": "Junior Coordinator",
        "instaLink": "",
        "linkedinLink": "",
    },*/
    
    
    
    
    
    /*{
        "url": require('../Assets/FinalYearImg/Saloni Singh .jpg'),
        "name": "Saloni Singh",
        "position": "Junior Coordinator",
        "instaLink": "https://www.instagram.com/_saloni_2807_?r=nametag",
        "linkedinLink": "https://www.linkedin.com/in/saloni-singh-08955a2b7?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },*/
    /*{
        "url": require('../Assets/FinalYearImg/Saransh Charchit.jpeg'),
        "name": "Saransh Charchit",
        "position": "Junior Coordinator",
        "instaLink": "https://www.instagram.com/sarans.h40?r=nametag",
        "linkedinLink": "https://https://www.linkedin.com/in/saransh-charchit-bb19a02ba?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },*/
    
    
    /*{
        "url": require('../Assets/FinalYearImg/Shresth Kamal Jha .jpg'),
        "name": "Shresth Kamal Jha",
        "position": "Junior Coordinator",
        "instaLink": "https://www.instagram.com/shresth_jha_815?r=nametag",
        "linkedinLink": "https://www.linkedin.com/in/shresth-kamal-jha-74b893281?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },*/


    
    /*{
        "url": require('../Assets/FinalYearImg/Suyash.png'),
        "name": "Suyash",
        "position": "Junior Coordinator",
        "instaLink": "",
        "linkedinLink": "https://www.linkedin.com/in/suyash-kumar-09ab83232",
    },*/

    /*{
        "url": require('../Assets/FinalYearImg/Akshit Kumar Jha.png'),
        "name": "Akshit Kumar Jha",
        "position": "Junior Coordinator",
        "instaLink": "https://www.instagram.com/_amansingh1007_?r=nametag",
        "linkedinLink": "https://www.linkedin.com/in/akshit-jha-23a0841a0",
    },


    {
        "url": require('../Assets/FinalYearImg/Vivek Dinkar.jpg'),
        "name": "Vivek Dinkar",
        "position": "Junior Coordinator",
        "instaLink": "https://www.instagram.com/dinkarvivek.nitd__0112?r=nametag",
        "linkedinLink": "",
    },*/
    /*{
        "url": require('../Assets/FinalYearImg/Priya Saroj.png'),
        "name": "Priya Saroj",
        "position": "Junior Coordinator",
        "instaLink": "https://www.instagram.com/priya_saroj2203?r=nametag",
        "linkedinLink": "",
    },*/
    
    
    
    
    
    

]
